import { Body } from "@songtradr-one/components-frontend";
import { Flex } from "@songtradr-one/shared-frontend";
import { Props, StaticItem } from "./UserMenuItem.Parts";

export const UserMenuItem = ({ firstName, lastName, email }: Props) => (
  <StaticItem>
    <Flex $direction="column" $gap="0" $fullWidth>
      <Flex $justify="space-between">
        <Body variant="normal-strong">
          {firstName} {lastName}
        </Body>
      </Flex>
      <Body color="shade400" variant="small">
        {email}
      </Body>
    </Flex>
  </StaticItem>
);
